import React, { useState, useEffect } from "react";
import { connect } from "dva";
import {
  Row,
  Col,
  Card,
  Statistic,
  Alert,
  Button,
} from "antd";
import moment from "moment";
import Apploader from "./../../components/loader/loader";

const Dashboard = (props) => {
  const { dispatch } = props;
  const [details, setDetails] = useState({});
  const [role, setRole] = useState("");
  const [detailData, setDetailData] = useState({});
  const [verified, setVerified] = useState(false);
  const [storeVerified, setStoreVerified] = useState(false);
  const [flatpin, setFlatPin] = useState([]);
  const [lastpin, setLastPin] = useState([]);

  useEffect(() => {
    document.title = "Dashboard";
    setRole(localStorage.getItem("role"));
    getDashbordDetail();
  }, []);

  const getDashbordDetail = async () => {
    const userId = localStorage.getItem("userId");
    dispatch({
      type: "account/getDashbordDetail",
      payload: { start_date: "", user_id: userId },
    });
  };

  useEffect(() => {
    const detail = props.account.dashborddetail?.countData;
    if (!detail) return;

    setDetails(detail);
    setDetailData({ countData: detail });
    setVerified(!!detail.isStore);
    setStoreVerified(!!detail.isStoreVerifed);

    const flat = detail.Pins_List?.filter((val) => val.categories === "FLAT_DISCOUNT_PIN") || [];
    const last = detail.Pins_List?.filter((val) => val.categories === "LAST_MINUTE_PIN") || [];

    setFlatPin(flat);
    setLastPin(last);
  }, [props.account.dashborddetail]);

  const formatTime = (timeStr) => {
    if (!timeStr) return "N/A";
    const m = moment(timeStr, ["HH:mm:ss", "HH:mm", "h:mm A"], true);
    return m.isValid() ? m.format("hh:mm A") : "N/A";
  };

  return (
    <div>
      <Apploader show={props.loading.global} />

      {role !== "ADMIN" ? (
        <>
          {!storeVerified && verified && (
            <Alert
              description="Your request is received by Hunt verification team, our team is verifying your store details and you will be notified as soon as your account is verified."
              type="warning"
              className="mb-4"
            />
          )}

          {verified ? (
            <Row gutter={15} className="mobile_dashboard">
              <Col xs={12} sm={6} md={4}>
                <Card className="card_hover" onClick={() => props.history.push("/pins")}>
                  <Statistic title="Total Pins" value={details.Total_Pins || 0} />
                </Card>
                <br />
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Card className="card_hover" onClick={() => props.history.push("/products")}>
                  <Statistic title="Total Products" value={details.Total_Products || 0} />
                </Card>
                <br />
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Card className="card_hover" onClick={() => props.history.push("/orders")}>
                  <Statistic title="Total Orders" value={details.Total_Student || 0} />
                </Card>
                <br />
              </Col>

              <Col xs={12} sm={6} md={4}>
                <Card className="card_hover" onClick={() => props.history.push("/")}>
                  <Statistic title="Return Orders" value={details.Total_Employee || 0} />
                </Card>
                <br />
              </Col>

              <Col xs={24} sm={12} md={12}>
                <Card title="Store Detail">
                  {details.Store_List && details.Store_List.length > 0 ? (
                    (() => {
                      const store = details.Store_List[0];
                      return (
                        <>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Store Name</span></Col>
                            <Col span={16}>{store.title || "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Store Cuisine</span></Col>
                            <Col span={16}>{store.cuisine?.join(", ") || "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Store Category</span></Col>
                            <Col span={16}>{store.store_category || "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Store Open Time</span></Col>
                            <Col span={16}>{formatTime(store.open_time)}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Store Close Time</span></Col>
                            <Col span={16}>{formatTime(store.close_time)}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>State</span></Col>
                            <Col span={16}>{store.state || "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>City</span></Col>
                            <Col span={16}>{store.city || "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Postal</span></Col>
                            <Col span={16}>{store.postal || "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Store Address</span></Col>
                            <Col span={16}>{store.address || "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Created At</span></Col>
                            <Col span={16}>{store.created_at ? moment(store.created_at).format("DD-MM-YYYY") : "-"}</Col>
                          </Row>
                          <Row style={{ marginBottom: "0.625rem" }}>
                            <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Status</span></Col>
                            <Col span={16}>
                              <span style={{ color: store.status ? "green" : "red" }}>
                                {store.status ? "Publish" : "UnPublish"}
                              </span>
                            </Col>
                          </Row>
                        </>
                      );
                    })()
                  ) : (
                    <p>No store data available.</p>
                  )}
                </Card>
              </Col>

              <Col xs={24} sm={12} md={12}>
                <Card title="Contact Info">
                  <Row style={{ marginBottom: "0.625rem" }}>
                    <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Email</span></Col>
                    <Col span={16}>{details.get_UserInfo?.email || "-"}</Col>
                  </Row>
                  <Row style={{ marginBottom: "0.625rem" }}>
                    <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Mobile Number</span></Col>
                    <Col span={16}>{details.get_UserInfo?.mobile_number || "-"}</Col>
                  </Row>
                </Card>

                <Card
                  title={
                    <div className="d-flex justify-content-between">
                      <span>FLAT DISCOUNT PIN</span>
                      {flatpin.length === 0 && (
                        <Button type="primary" onClick={() => props.history.push("/pin/add/FLAT_DISCOUNT_PIN?redirect=dashboard")}>
                          Add Flat Discount Pin
                        </Button>
                      )}
                    </div>
                  }
                  style={{ marginTop: "1rem" }}
                >
                  {flatpin.length === 0 ? <p>Please Add Pin</p> : (
                    <>
                      <Row style={{ marginBottom: "0.625rem" }}>
                        <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Title</span></Col>
                        <Col span={16}>{flatpin[0]?.title || "-"}</Col>
                      </Row>
                      <Row style={{ marginBottom: "0.625rem" }}>
                        <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Status</span></Col>
                        <Col span={16}>
                          <span style={{ color: flatpin[0]?.is_published ? "green" : "red" }}>
                            {flatpin[0]?.is_published ? "Publish" : "UnPublish"}
                          </span>
                        </Col>
                      </Row>
                    </>
                  )}
                </Card>

                <Card
                  title={
                    <div className="d-flex justify-content-between">
                      <span>LAST MINUTES PIN</span>
                      {lastpin.length === 0 && (
                        <Button type="primary" onClick={() => props.history.push("/product/add?redirect=dashboard")}>
                          Add Last Minute Pin
                        </Button>
                      )}
                    </div>
                  }
                  style={{ marginTop: "1rem" }}
                >
                  {lastpin.length === 0 ? <p>Please Add Pin</p> : (
                    <>
                      <Row style={{ marginBottom: "0.625rem" }}>
                        <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Title</span></Col>
                        <Col span={16}>{lastpin[0]?.title || "-"}</Col>
                      </Row>
                      <Row style={{ marginBottom: "0.625rem" }}>
                        <Col span={8}><span style={{ color: "#666", fontWeight: "700" }}>Status</span></Col>
                        <Col span={16}>
                          <span style={{ color: lastpin[0]?.is_published ? "green" : "red" }}>
                            {lastpin[0]?.is_published ? "Publish" : "UnPublish"}
                          </span>
                        </Col>
                      </Row>
                    </>
                  )}
                </Card>
              </Col>

              <Col span={24} className="mb-5"></Col>
            </Row>
          ) : (
            <>
              <Button type="primary" className="mb-4" onClick={() => props.history.push("/store/add?verify=verify")}>
                Add Store
              </Button>
              <Alert message="Please Add Your Store" type="error" description="You need to add your store to get started." />
            </>
          )}
        </>
      ) : (
        // ✅ Admin View
        <>
          <Row gutter={15} className="mobile_dashboard">

            <Col xs={12} sm={6} md={4}>
              <Card className="card_hover card-shadow" onClick={() => props.history.push("/approve")}>
                <Statistic title="Pending Approvals" value={details.Pending_Approval?.length || 0} />
              </Card>
              <br />
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Card className="card_hover card-shadow" onClick={() => props.history.push("/customers")}>
                <Statistic title="Total Users" value={details.GetTotalUsers || 0} />
              </Card>
              <br />
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Card className="card_hover card-shadow" onClick={() => props.history.push("/store-users")}>
                <Statistic title="Total Retailers" value={details.Total_Store || 0} />
              </Card>
              <br />
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Card className="card_hover card-shadow" onClick={() => props.history.push("/stores")}>
                <Statistic title="Total Stores" value={details.Total_Store || 0} />
              </Card>
              <br />
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Card className="card_hover card-shadow" onClick={() => props.history.push("/pins")}>
                <Statistic title="Total Pins" value={details.Total_Pins || 0} />
              </Card>
              <br />
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Card className="card_hover card-shadow" onClick={() => props.history.push("/orders")}>
                <Statistic title="Total Orders" value={details.Total_Employee || 0} />
              </Card>
              <br />
            </Col>

          </Row>

          {details.Pending_Approval?.map((val) => {
            const msg = `${val.userInfo?.username} added a new store "${val.storeInfo?.title}" and requests approval.`;
            return (
              <Alert
                key={val.store_id}
                description={msg}
                type="error"
                className="card_hover mb-3"
                onClick={() => props.history.push(`/store/view/${val.store_id}?redirect=approve`)}
                style={{ cursor: "pointer" }}
              />
            );
          })}
        </>
      )}
    </div>
  );
};

export default connect(({ account, loading }) => ({
  account,
  loading,
}))(Dashboard);